import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'
import { ReactComponent as Icon } from '../svgs/E3_edit_page.svg'

const E3EditPage: React.FC<SvgIconProps> = props => (
  <SvgIcon
    viewBox="0 0 76 76"
    component={Icon}
    sx={theme => ({ '--icon-primary-color': theme.palette.primary.main })}
    {...props}
    fill="currentColor"
  />
)
export default E3EditPage
